<template lang="pug">
  div(data-testid="content-no-image-list")
    section.content-header
      app-messages(:errorMessages="errors", :successMessages="successes")

      h1 画像未登録名刺

    section.content
      .callout.callout-info.bcard-callout
        p 名刺画像が登録されていない名刺を表示しています。
        p
          i.fa.fa-fw.fa-exclamation-circle
          |
          |
          | 管理をしやすくするため、できるだけ名刺画像を登録してください。

      .panel.panel-default
        .panel-heading
          .row
            .col-xs-6
              //- 検索
              func-advanced-search(
                @search="getList",
                v-model="conditions",
                :init="initParams.conds",
                :show="['exchange_date_from', 'exchange_date_to', 'search_target_opt']",
                :search-target-options="{'0': '自分が最新の名刺交換者である名刺', '1': '自分が登録した名刺すべて'}"
              )
            .col-xs-6.text-right
              //- 一覧切り替えボタン
              portal-target(name="list_mode", tag="span")
              | &nbsp;&nbsp;
              app-sortmenu(:hidden="list.length === 0", :options="sortOptions", :current="sort" @change="sortList")

        loading(v-if="isLoading")
        card-list(
          v-else-if="list.length > 0",
          v-model="list",
          :sort="sort"
        )
        .panel-body.text-center(v-else) 検索に該当する名刺はありません。

      app-pagination(:is-loading="isLoading", :pagination="pagination", @change="getList")
</template>

<script>
import mixinList from '@/mixins/list'
import AppMessages from '@/components/molecules/AppMessages'
import AppPagination from '@/components/molecules/AppPagination'
import AppSortmenu from '@/components/molecules/AppSortmenu'
import Loading from '@/components/molecules/Loading'
import FuncAdvancedSearch from '@/components/organisms/functions/FuncAdvancedSearch'
import CardList from '@/components/organisms/lists/CardList'

const date = new Date()
const year = date.getFullYear()
const month = date.getMonth() + 1
const day = date.getDate()
const exchange_date_from = `${year - 1}/${month}/${day}`
const exchange_date_to = `${year}/${month}/${day}`

export default {
  name: 'NoimageBcards',
  components: {
    AppMessages,
    AppPagination,
    AppSortmenu,
    Loading,
    FuncAdvancedSearch,
    CardList
  },
  mixins: [ mixinList ],
  data () {
    return {
      isLoading: true,

      // ソート項目リスト
      sortOptions: [
        {'label': '氏名', 'sort_item': 'name'},
        {'label': '会社名', 'sort_item': 'corporate_name'},
        {'label': '部署名', 'sort_item': 'dept'},
        {'label': '役職', 'sort_item': 'post'},
        {'label': '名刺交換日', 'sort_item': 'exchange_date'}
      ],

      // 初期条件
      initParams: {
        // ページ条件
        page: { page: 1 },
        // ソート条件
        sort: { sort_item: 'name', direction: 'asc' },
        // 検索条件
        conds: {
          search_target_opt: '0', // 初期値0: 自分が最新の名刺交換者である名刺
          exchange_date_from,
          exchange_date_to
        }
      }
    }
  },
  created () {
    // サイドメニューから遷移した場合、mixinListで取得しているstoreの条件を上書きする
    if (this.$route.params.init) {
      this.pagination = Object.assign({}, this.initParams.page)
      this.sort = Object.assign({}, this.initParams.sort)
      this.conditions = Object.assign({}, this.initParams.conds)
    }

    // 初期データ取得
    this.getList()
  },
  methods: {
    /**
     * 一覧取得処理
     * @params options
     *    page: ページ条件
     *    sort: ソート条件
     *    conds: 検索条件
     */
    getList (options) {
      const vm = this

      options = options || {}

      let page = options.page || this.pagination.current_page || 1
      let sort = options.sort || this.sort || {}
      let conds = options.conds || this.conditions || {}

      let params = {
        // page
        page,
        // sort
        sort_item: sort.sort_item,
        direction: sort.direction,
        // conditions
        search_target_noimage: conds.search_target_opt,
        exchange_date_from: conds.exchange_date_from || '',
        exchange_date_to: conds.exchange_date_to || ''
      }

      this.clearErrorMessages()
      this.isLoading = true

      // 一覧取得
      this.sendListRequest({
        repo: this.isMgmt ? 'managebcard' : 'bcard',
        method: 'searchNoimage',
        params,
        onSuccess (response) {
          // sendListRequestでやってるsetListCondsをやり直し
          vm.conditions = Object.assign({}, conds, sort) // condsにもsortがあるのでsortが後
          vm.setListConds()
        },
        finally () {
          vm.isLoading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/maintenance/noimage-bcards/Index.vue